module.exports = __webpack_public_path__ + "img/gs2.6e42436e.png";